module.exports = __webpack_public_path__ + "static/media/Chakras.2cf9ad32.jpg";